import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Layouts/Navbar";
import LeftSideBar from "./components/Layouts/LeftSideBar";
import ManageContentPage from "./components/cms/managecontentpage/ManageContentPage";
import ManageSlider from "./components/cms/manageSlider/ManageSlider";
import Footer from "./components/Layouts/Footer";
import AddContentPage from "./components/cms/managecontentpage/AddContentPage";
import AddSlider from "./components/cms/manageSlider/AddSlider";
import ManageSeoPage from "./components/cms/manageseopage/ManageSeoPage";
import ManageTestimonials from "./components/cms/managetestimonials/ManageTestimonials";
import AddSeoPage from "./components/cms/manageseopage/AddSeoPage";
import AddNewTestimonials from "./components/cms/managetestimonials/AddNewTestimonials";
import ManageAddBanner from "./components/cms/manageadsbanner/ManageAdsBanner";
import AddNewBanner from "./components/cms/manageadsbanner/AddNewBanner";
import ManagePricingPlans from "./components/pricingplans/pricingplans/ManagePricingPlans";
import AddPricingPlan from "./components/pricingplans/pricingplans/AddPricingPlan";
import EditContentPage from "./components/cms/managecontentpage/EditContentPage";
import EditSlider from "./components/cms/manageSlider/EditSlider";
import EditSeoPage from "./components/cms/manageseopage/EditSeoPage";
import EditTestimonials from "./components/cms/managetestimonials/EditTestimonials";
import EditAdsBanner from "./components/cms/manageadsbanner/EditAdsBanner";
import EditPricingPlan from "./components/pricingplans/pricingplans/EditPricingPlan";
import AddFaq from "./components/cms/faq/AddFaq";
import ManageFaqs from "./components/cms/faq/ManageFaqs";
import EditFaq from "./components/cms/faq/EditFaq";
import Login from "./components/Login/Login";
import ManagePage from "./components/cms/managepage/ManagePage";
import AddPage from "./components/cms/managepage/AddPage";
import EditPage from "./components/cms/managepage/EditPage";
import ManageLogoPage from "./components/cms/logo/ManageLogoPage";
import AddLogoPage from "./components/cms/logo/AddLogo";
import Dashboard from "./components/Dashboard";
import { useNavigate, Navigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotFoundPage from "./components/cms/NotFoundPage";
import ManageSocialMedia from "./components/cms/mangesocialmedia/MangeSocialMedia";
import AddSocials from "./components/cms/mangesocialmedia/AddSocials";
import EditSocials from "./components/cms/mangesocialmedia/EditSocials";
import ManageIndustry from "./components/cms/managerIndustry/ManageIndustry";
import AddIndustry from "./components/cms/managerIndustry/AddIndustry";
import EditIndustry from "./components/cms/managerIndustry/EditIndustry";
import ManageEnquiry from "./components/cms/manageenquiry/manageenquiry";
import NegativeEnquiry from "./components/cms/manageenquiry/negativeenquiry";
import AddEnquiry from "./components/cms/manageenquiry/addenquiry";
import ManageSubscribe from "./components/cms/managesubscribe/managesubscribe";
import ManageCompanyProfile from "./components/cms/manageconpanyprofile/managecompanyprofile";
import AddCompanyProfile from "./components/cms/manageconpanyprofile/addcompanyprofile";
import ManageClient from "./components/cms/manageclient/manageclient";
import AddClient from "./components/cms/manageclient/addClient";
import CompanyInformation from "./components/cms/companyInformation/companyinformation";
import {
  isLoggedIn,
  loginFailure,
  selectUser,
  setTicketUnreadCount,
} from "../src/components/store/auth/authSlice";
import axios from "axios";
import { EMAIL_API_URL } from "./components/config";
import { setupAxiosInterceptors } from "./setupAxiosInterceptors";
import { persistor } from "../src/components/store/store";
import { Provider, useDispatch, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import AddSubscription from "./components/cms/managePlans/manageSubscriptionPlan";
import EditPlan from "./components/cms/managePlans/editSubscriptionPlan";
import ManageUserData from "./components/cms/manageUserData/manageUserList";
// import ViewUserDetail from "./components/cms/manageUserData/viewUserDetail";
import UserProfile from "./components/cms/manageUserData/UserProfile/UserProfile";
import User360View from "./components/cms/manageUserData/UserProfile/User360View";
import EditUser from "./components/cms/manageUserData/editUser";
import { API_BASE_URL } from "./components/config";
import ManageTrademark from "./components/cms/Manage-Trademark-Data/Manage_Trademark/Index";
import AddUser from "./components/cms/manageUserData/addUser";
import ManageSubscription from "./components/cms/managePlans/manageSubscriptionPlan";
import ManageGuestCustomer from "./components/cms/manageUserData/manageGuestList";
import Profile from "./components/Layouts/Profile";
import AddPlan from "./components/cms/managePlans/addSubscriptionPlan";
import CreateOrder from "./components/cms/manageUserData/createCustomerOrder/CreateOrder";
import PaymentApproval from "./components/cms/manageUserData/PaymentApproval";
import SubscriptionInbox from "./components/cms/manageUserData/SubscriptionInbox";

import ManageOrderList from "./components/cms/manageUserData/manageOrderList";
import { ActiveFreeTrialPage, PendingPaymentPage, ActivePaidPage, ExpiringSoonPage, PaidExpiredPage, FreeTrialExpiredPage } from "./components/cms/manageUserData/FilteredOrderPages";
// import CommunicationPage from "./components/cms/manageUserData/CommunicationPage";
import ManageSearch from "./components/cms/ManageSearch/Index";
import Detail from "./components/cms/Manage-Trademark-Data/Manage_Trademark/TrademarkDetail";
import ManageDocuments from "./components/cms/Manage-Trademark-Data/Manage_Documents";
import ManageApiHit from "./components/cms/ManageApi";
import ManageWalletHistory from "./components/cms/ManageWallet";
import ViewEnquiry from "./components/cms/manageenquiry/ViewEnquiry";
import ManageCustomerMenu from "./components/customer-dashboard/manage-dashboard-menu/ManageCustomerMenu";
import ManageCustomerRole from "./components/customer-dashboard/manage-role/ManageCustomerRole";
import UpsertCustomerRole from "./components/customer-dashboard/manage-role/UpsertCustomerRole";
import ManageSubPlanNew from "./components/cms/manage-plan-new/ManageSubPlanNew";
import AddSubscriptionPlanNew from "./components/cms/manage-plan-new/AddSubscriptionPlanNew";
import AddPlanFeatures from "./components/cms/manageFeatures/AddPlanFeatures";
import ManageSubFeatures from "./components/cms/manageFeatures/ManageSubFeatures";
import ManageElasticSearch from "./components/cms/manage-elastic-search/ManageElasticSearch";
import ManageTrademarkMisData from "./components/cms/manageTrademarkData/ManageTrademarkData";
import ManageCoupons from "./components/cms/manageCoupon/ManageCoupons";
import AddCoupon from "./components/cms/manageCoupon/AddCoupon";
import LeadInbox from "./components/cms/leadInbox/leadInbox";
import ManageTrademarkTrends from "./components/cms/manage-trademark-trends/ManageTrademarkTrends";
import ManageProprietorTrademarkData from "./components/cms/manage-trademark-trends/ManageProprietorTrademarkData";
import ManageAttorneyTrademarkData from "./components/cms/manage-trademark-trends/ManageAttorneyTrademarkData";
import FutureLeads from "./components/cms/manageenquiry/FutureLeads";
import DoneLeads from "./components/cms/manageenquiry/DoneLeads";
import DemoBookingList from "./components/cms/manageenquiry/DemoBookingList";
import DemoBookingDetail from "./components/cms/manageenquiry/DemoBookingDetail";
import AssignedLeads from "./components/cms/manageenquiry/AssignedLeads";
import LeadCommunication from "./components/cms/manageenquiry/LeadCommunication";
import TemplatesListPage from "./components/templates/TemplatesListPage";
import CreateEmailTemplate from "./components/templates/CreateEmailTemplate";
import CreateWhatsAppTemplate from "./components/templates/CreateWhatsAppTemplate";
import ManageRoles from "./components/cms/manage-roles/ManageRoles";
import ManagePermissions from "./components/cms/manage-permissions/ManagePermissions";
import ManageCmsMenus from "./components/cms/manage-cms-menus/ManageCmsMenus";
import ManageTeamMembers from "./components/cms/manage-team-members/ManageTeamMembers";
import CreateEditRole from "./components/cms/manage-roles/CreateEditRole";
import CreateEditTeamMember from "./components/cms/manage-team-members/CreateEditTeamMember";
import ProtectedRoute from "./components/ProtectedRoute";
import PaidUsers from "./components/cms/paid-users/PaidUsers";
import FreeTrialUsers from "./components/cms/free-trial-users/FreeTrialUsers";
import PaymentList from "./components/cms/payment-list/PaymentList";
import TicketList from "./components/cms/tickets/TicketList";
import TicketDetail from "./components/cms/tickets/TicketDetail";
import CustomerFollowUp from "./components/cms/manageUserData/CustomerFollowUp";
import EmailInbox from "./components/cms/inbox/EmailInbox";
import OutlookConnected from "./components/cms/inbox/OutlookConnected";
import LeadInboxEmail from "./components/cms/manageenquiry/LeadInbox";
import BulkEmailPage from "./components/cms/BulkEmailSender/BulkEmailPage";
import BulkEmailCompose from "./components/cms/BulkEmailSender/BulkEmailCompose";

setupAxiosInterceptors();

// Saves the intended route to sessionStorage before bouncing to login, so Login
// can redirect back there after a successful authentication.
const RedirectToLogin = () => {
  const location = useLocation();
  const intended = location.pathname + (location.search || "");
  if (intended && intended !== "/" && intended !== "/cms/login") {
    sessionStorage.setItem("postLoginRedirect", intended);
  }
  return <Navigate to="/cms/login" replace />;
};

function App() {
  const user = useSelector(selectUser);
  const loggedIn = useSelector(isLoggedIn);
  const dispatch = useDispatch();
  const location = useLocation();
  const [token, setToken] = useState(localStorage.getItem("cms_token"));

  useEffect(() => {
    if (!loggedIn) return;
    const internalUserId = Number(localStorage.getItem("trade_user_id"));
    if (!internalUserId) return;
    const fetchUnread = async () => {
      try {
        const res = await axios.get(`${EMAIL_API_URL}/api/single-email/unread-count`, {
          params: { internalUserId },
          headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}` },
        });
        dispatch(setTicketUnreadCount(res.data?.count || 0));
      } catch { /* silent fail */ }
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);
    return () => clearInterval(interval);
  }, [loggedIn, dispatch]);
  const [islogin, setIslogin] = useState(true);
  const navigate = useNavigate();
  // console.log(location.pathname,"pathname");
  useEffect(() => {
    // websitelogo();
    setToken(localStorage.getItem("cms_token"));
    let path = window.location.pathname;
    // console.log(path, "path");
    // if(localStorage.getItem("cms_token")){
    //   navigate("/cms/home");
    // };
    const getFirstAccessibleRoute = () => {
      const menuAccess = JSON.parse(localStorage.getItem("cms_menu_access") || "[]");
      for (const menu of menuAccess) {
        if (menu.menu_link) return menu.menu_link;
        const first = menu.sub_menus?.find((sm) => sm.sub_menu_link);
        if (first) return first.sub_menu_link;
      }
      return "/cms/home";
    };

    if (location.pathname == "/") {
      if (localStorage.getItem("cms_token")) {
        navigate(getFirstAccessibleRoute());
      } else {
        dispatch(loginFailure());
        navigate("/cms/login");
      }
    }
    if (token) {
      loadContent();
    }
    // if (token === null) {
    //   setIslogin(false);
    //   localStorage.clear();
    //   navigate("/cms/login");
    // } else {
    //   navigate("/cms/home")
    //   setIslogin(true);
    // }
  }, [token, location.pathname]);

  const loadContent = async () => {
    await axios
      .get(`${API_BASE_URL}/get-slider`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
          "content-type": "multipart/form-data",
        },
      })
      .catch(() => {});
    // 401 handling is done globally via setupAxiosInterceptors
  };

  // const websitelogo = async () => {
  //   try {
  //     const logo = await axios.get(API_BASE_URL + "/get-web-company-profile");
  //     const weblogo = JSON.parse(JSON.stringify(logo.data));
  //     if (weblogo.status == 200) {
  //       localStorage.setItem("logo_url", weblogo.data.logo);
  //       var link =
  //         document.querySelector("link[rel*='icon']") ||
  //         document.createElement("link");
  //       link.type = "image/x-icon";
  //       link.rel = "shortcut icon";
  //       link.href = weblogo.data.favicon_icon;
  //       document.getElementsByTagName("head")[0].appendChild(link);
  //       document
  //         .querySelector('link[rel="icon"]')
  //         .setAttribute("href", weblogo.data.favicon_icon);
  //       document
  //         .querySelector('link[rel="canonical"]')
  //         .setAttribute("href", weblogo.data.website);
  //     }
  //   } catch (e) {
  //     return false;
  //   }
  // };

  return (
    <div>
      <>
        <PersistGate loading={null} persistor={persistor}>
          <ToastContainer />
          {!loggedIn ? (
            <>
              <Routes>
                <Route path="/cms/login" element={<Login />} />
                <Route path="*" element={<RedirectToLogin />} />
              </Routes>
            </>
          ) : (
            <>
              <Navbar />
              <LeftSideBar />
              <Footer />
              <Routes>
                <Route element={<ProtectedRoute />}>
                <Route path="/cms/home" element={<Dashboard />} />
                <Route path="/cms/managelogo" element={<ManageLogoPage />} />
                <Route
                  path="/cms/managelogo/addlogo"
                  element={<AddLogoPage />}
                />
                <Route path="/cms/managepage" element={<ManagePage />} />
                <Route
                  path="/cms/managepage/editpage/:id"
                  element={<EditPage />}
                />
                <Route path="/cms/managepage/addpage" element={<AddPage />} />
                <Route
                  path="/cms/managecontentpage"
                  element={<ManageContentPage />}
                />
                <Route
                  path="/cms/managecontentpage/addcontentpage"
                  element={<AddContentPage />}
                />
                <Route
                  path="/cms/managecontentpage/addcontentpage/:id"
                  element={<AddContentPage />}
                />
                <Route path="/cms/manageslider" element={<ManageSlider />} />
                <Route
                  path="/cms/manageslider/addnewslider"
                  element={<AddSlider />}
                />
                <Route
                  path="/cms/manageslider/edit-slider/:id"
                  element={<AddSlider />}
                />
                <Route path="/cms/manageseopage" element={<ManageSeoPage />} />
                <Route
                  path="/cms/manageseopage/addseopage"
                  element={<AddSeoPage />}
                />
                <Route
                  path="/cms/manageseopage/editseopage/:id"
                  element={<AddSeoPage />}
                />
                <Route
                  path="/cms/managetestimonials"
                  element={<ManageTestimonials />}
                />
                <Route
                  path="/cms/managetestimonials/addnewtestimonials"
                  element={<AddNewTestimonials />}
                />
                <Route
                  path="/cms/managetestimonials/edittestimonials/:id"
                  element={<AddNewTestimonials />}
                />
                <Route
                  path="/cms/mangeadsbanner"
                  element={<ManageAddBanner />}
                />
                <Route
                  path="/cms/mangeadsbanner/addnewbanner"
                  element={<AddNewBanner />}
                />
                <Route
                  path="/cms/mangeadsbanner/editadsbanner/:id"
                  element={<EditAdsBanner />}
                />
                <Route
                  path="/cms/managepricingplans"
                  element={<ManagePricingPlans />}
                />
                <Route
                  path="/cms/managepricingplans/addpricingplans"
                  element={<AddPricingPlan />}
                />
                <Route
                  path="/cms/managepricingplans/editpricingplans"
                  element={<EditPricingPlan />}
                />
                <Route path="/cms/managefaq" element={<ManageFaqs />} />
                <Route path="/cms/managefaq/addfaq" element={<AddFaq />} />
                <Route
                  path="/cms/managefaq/editfaq/:id"
                  element={<EditFaq />}
                />
                <Route
                  path="/cms/managesocialmedia"
                  element={<ManageSocialMedia />}
                />
                <Route
                  path="/cms/managesocialmedia/addsocials"
                  element={<AddSocials />}
                />
                <Route
                  path="/cms/managesocialmedia/editsocials/:id"
                  element={<EditSocials />}
                />
                <Route
                  path="/cms/manageindustry"
                  element={<ManageIndustry />}
                />
                <Route
                  path="/cms/manageindustry/addindustry"
                  element={<AddIndustry />}
                />
                <Route
                  path="/cms/manageindustry/editindustry/:id"
                  element={<EditIndustry />}
                />
                <Route path="*" element={<NotFoundPage />} />
                <Route path="/cms/manageenquiry" element={<ManageEnquiry />} />
                <Route
                  path="/cms/manageEnquiry/edit-enquiry/:id"
                  element={<ViewEnquiry />}
                />
                {/* <Route
                  path="/cms/manageenquiry/inbox"
                  element={<PositiveEnquiry />}
                /> */}
                <Route
                  path="/cms/manageenquiry/inbox"
                  element={<LeadInboxEmail />}
                />
                <Route
                  path="/cms/manageenquiry/future"
                  element={<FutureLeads />}
                />
                <Route path="/cms/manageenquiry/done" element={<DoneLeads />} />
                <Route path="/leads/demo-booking" element={<DemoBookingList />} />
                <Route path="/leads/demo-booking/:lead_id" element={<DemoBookingDetail />} />
                <Route path="/leads/assigned-leads" element={<AssignedLeads />} />
                <Route path="/leads/:lead_id/followup" element={<LeadCommunication />} />
                <Route
                  path="/cms/manageenquiry/negative-enquiry"
                  element={<NegativeEnquiry />}
                />
                <Route
                  path="/cms/leadInbox/lead-inbox"
                  element={<LeadInbox />}
                />
                <Route
                  path="/cms/manageenquiry/add-enquiry"
                  element={<ViewEnquiry />}
                />
                <Route
                  path="/cms/manage-customer-dashboard-menu"
                  element={<ManageCustomerMenu />}
                />
                <Route
                  path="/cms/manage-customer-role"
                  element={<ManageCustomerRole />}
                />
                <Route
                  path="/cms/add-customer-role"
                  element={<UpsertCustomerRole />}
                />
                <Route
                  path="/cms/edit-customer-role/:id"
                  element={<UpsertCustomerRole />}
                />
                <Route path="/cms/manage-roles" element={<ManageRoles />} />
                <Route
                  path="/cms/manage-roles/create"
                  element={<CreateEditRole />}
                />
                <Route
                  path="/cms/manage-roles/edit/:id"
                  element={<CreateEditRole />}
                />
                <Route
                  path="/cms/manage-permissions"
                  element={<ManagePermissions />}
                />
                <Route
                  path="/cms/manage-team-members"
                  element={<ManageTeamMembers />}
                />
                <Route
                  path="/cms/manage-team-members/create"
                  element={<CreateEditTeamMember />}
                />
                <Route
                  path="/cms/manage-team-members/edit/:id"
                  element={<CreateEditTeamMember />}
                />
                <Route
                  path="/cms/manage-cms-menus"
                  element={<ManageCmsMenus />}
                />
                <Route
                  path="/cms/managesubscribe"
                  element={<ManageSubscribe />}
                />
                <Route
                  path="/cms/managecompanyprofile"
                  element={<ManageCompanyProfile />}
                />
                <Route
                  path="/cms/managecompanyprofile/add-company-profile"
                  element={<AddCompanyProfile />}
                />
                <Route
                  path="/cms/companyinformation"
                  element={<CompanyInformation />}
                />
                <Route
                  path="/cms/managecompanyprofile/add-company-profile/:id"
                  element={<AddCompanyProfile />}
                />
                <Route path="/cms/manageSponser" element={<ManageClient />} />
                <Route
                  path="/cms/manageSponser/add-sponser"
                  element={<AddClient />}
                />
                <Route
                  path="/cms/manageSponser/edit-sponser/:id"
                  element={<AddClient />}
                />
                {/* All Templates (list page) */}
                <Route path="/cms/templates" element={<TemplatesListPage />} />
                {/* Email Template - Create & Edit */}
                <Route
                  path="/cms/templates/email/create"
                  element={<CreateEmailTemplate />}
                />
                <Route
                  path="/cms/templates/email/:id/edit"
                  element={<CreateEmailTemplate />}
                />
                {/* WhatsApp Template - Create & Edit */}
                <Route
                  path="/cms/templates/whatsapp/create"
                  element={<CreateWhatsAppTemplate />}
                />
                <Route
                  path="/cms/templates/whatsapp/:id/edit"
                  element={<CreateWhatsAppTemplate />}
                />
                {/* <Route
                  path="/cms/manage-subscription-plan"
                  element={<ManageSubscription />}
                /> */}
                <Route
                  path="/cms/manage-subscription-plan"
                  element={<ManageSubPlanNew />}
                />
                <Route
                  path="/cms/manage-plan-new/add-subscription-plan-new"
                  element={<AddSubscriptionPlanNew />}
                />
                <Route
                  path="/cms/manage-plan-new/edit-subscription-plan-new/:id"
                  element={<AddSubscriptionPlanNew />}
                />
                <Route
                  path="/cms/manage-subscription-features"
                  element={<ManageSubFeatures />}
                />
                <Route
                  path="/cms/manage-subscription-features/add-subscription-features"
                  element={<AddPlanFeatures />}
                />
                <Route
                  path="/cms/manage-subscription-features/edit-subscription-features/:id"
                  element={<AddPlanFeatures />}
                />
                <Route
                  path="/cms/managePlan/add-subscription-plan"
                  element={<AddPlan />}
                />
                <Route
                  path="/cms/managePlan/edit-subscription-plan/:id"
                  element={<EditPlan />}
                />
                <Route
                  path="/cms/manage-elastics-search"
                  element={<ManageElasticSearch />}
                />
                <Route
                  path="/cms/manage-trademark-trends"
                  element={<ManageTrademarkTrends />}
                />
                <Route
                  path="/cms/manage-proprietor-data/:id"
                  element={<ManageProprietorTrademarkData />}
                />
                <Route
                  path="/cms/manage-attorney-data/:id"
                  element={<ManageAttorneyTrademarkData />}
                />
                <Route
                  path="/cms/manage-customer"
                  element={<ManageUserData />}
                />
                <Route
                  path="/cms/manage-guest-customer"
                  element={<ManageGuestCustomer />}
                />
                <Route
                  path="/cms/manageUserData/user-profile/:id"
                  element={<UserProfile />}
                />
                <Route
                  path="/cms/manageUserData/user-360-view/:id"
                  element={<User360View />}
                />
                <Route
                  path="/cms/manageUserData/editUser/:id"
                  element={<EditUser />}
                />
                <Route
                  path="/cms/manageUserData/addUser"
                  element={<AddUser />}
                />
                <Route path="/cms/manage-customer/manage-order" element={<ManageOrderList />} />
                <Route path="/cms/manage-customer/active-free-trial" element={<ActiveFreeTrialPage />} />
                <Route path="/cms/manage-customer/pending-payment" element={<PaymentApproval />} />
                <Route path="/cms/manage-customer/active-paid" element={<ActivePaidPage />} />
                <Route path="/cms/manage-customer/expiring-soon" element={<ExpiringSoonPage />} />
                <Route path="/cms/manage-customer/paid-expired" element={<PaidExpiredPage />} />
                <Route path="/cms/manage-customer/free-trial-expired" element={<FreeTrialExpiredPage />} />
                <Route path="/cms/manage-customer/subscription-inbox" element={<SubscriptionInbox />} />
                <Route
                  path="/cms/manage-customer/create-order"
                  element={<CreateOrder />}
                />
                <Route
                  path="/cms/manage-customer/edit-order/:order_id/:user_id"
                  element={<CreateOrder />}
                />
                <Route
                  path="/cms/manage-customer/customerfollowup/:customerId"
                  element={<CustomerFollowUp />}
                />
                <Route
                  path="/cms/inbox"
                  element={<EmailInbox />}
                />
                <Route
                  path="/cms/outlook-connected"
                  element={<OutlookConnected />}
                />
                <Route path="/send-bulk-mail" element={<BulkEmailPage />} />
                <Route path="/send-bulk-mail/compose" element={<BulkEmailCompose />} />
                {/* <Route
                  path="/cms/manage-customer/communications/:userId"
                  element={<CommunicationPage />}
                /> */}
                <Route
                  path="/cms/manage-trademark-data/manage-trademark"
                  element={<ManageTrademark />}
                />
                <Route
                  path="/cms/manage-trademark-data/view-trademark"
                  element={<Detail />}
                />
                {/* <Route path="/cms/manage-search" element={<ManageSearch />} /> */}
                <Route
                  path="/cms/manage-document"
                  element={<ManageDocuments />}
                />
                <Route path="/cms/manage-api" element={<ManageApiHit />} />7
                <Route
                  path="/cms/manage-wallet"
                  element={<ManageWalletHistory />}
                />
                <Route path="/cms/profile" element={<Profile />} />
                <Route
                  path="/cms/manage-trademark-mis-data"
                  element={<ManageTrademarkMisData />}
                />
                <Route path="/cms/manage-coupons" element={<ManageCoupons />} />
                <Route path="/cms/add-coupon" element={<AddCoupon />} />
                <Route path="/cms/edit-coupon/:id" element={<AddCoupon />} />
                <Route path="/cms/paid-users" element={<PaidUsers />} />
                <Route path="/cms/free-trial-users" element={<FreeTrialUsers />} />
                <Route path="/cms/payment-list" element={<PaymentList />} />
                <Route path="/cms/tickets" element={<TicketList />} />
                <Route path="/cms/tickets/:id" element={<TicketDetail />} />
                </Route>
              </Routes>
            </>
          )}
        </PersistGate>
      </>
    </div>
  );
}

export default App;
